export const classes = {
  image: 'object-contain',
};
